<template>
    <painel titulo="Links de Pagamentos - Filtros" :mostrarRefresh="false" v-if="mostrarListagem">
        <filtros @pesquisar="buscaLinks($event)" @limpar="buscaLinks($event)"></filtros>
    </painel>
    <painel titulo="Links" :refreshFunction="atualizar" :mostrarRefresh="false" v-if="mostrarListagem">
        <tabela
            :data="links"
            dataKey="checkoutId"
            :globalFilterFields="[
                'linkPagamento',
                'situacao',
                'produto.valor',
                'produto.valorFormatado',
                'dataCadastro',
                'dataCadastroFormatada',
                'nomeUsuarioCadastro',
                'situacaoDescricao',
                'identificadorPagamento',
                'tipoPagamentoDescricao',
                'cpf',
                'cpfFormatado',
                'nome',
                'produtoCheckoutId',
            ]"
            :stateKey="null"
        >
            <template #botoes>
                <btn-exportar :linksPagamentos="links"></btn-exportar>
                <btn-reenviar-email
                    @limparProdutoCheckoutsSelecionados="limparProdutoCheckoutsSelecionados($event)"
                    :produtoCheckoutsParaEnviarEmail="produtoCheckoutSelecionados"
                ></btn-reenviar-email>
                <btn-relatorio-conciliacao></btn-relatorio-conciliacao>
            </template>
            <template #conteudo>
                <Column headerStyle="width: 3rem">
                    <template #body="slotProps">
                        <Checkbox v-model="produtoCheckoutSelecionados" :value="slotProps.data.produtoCheckoutId" v-if="slotProps.data.situacao === 0" />
                    </template>
                </Column>
                <Column headerStyle="width: 3em">
                    <template #body="slotProps">
                        <div class="flex">
                            <font-awesome-icon
                                icon="info-circle"
                                @click="toDetalhar(slotProps.data)"
                                size="lg"
                                class="icon-button"
                                title="Detalhar"
                                style="color: #0772b3"
                            />
                        </div>
                    </template>
                </Column>
                <column field="linkPagamento" header="Link" :sortable="true">
                    <template #body="slotProps">
                        <a
                            style="color: #0772b3; text-decoration: underline; word-break: break-all; cursor: pointer"
                            @click.stop.prevent="abrirLink(slotProps.data?.linkPagamento)"
                        >
                            {{ slotProps.data?.linkPagamento }}
                        </a>
                    </template>
                </column>
                <column field="Evento" header="Evento" :sortable="true">
                    <template #body="slotProps">
                        <p style="cursor: pointer">{{ slotProps.data?.produto.titulo }}</p>
                    </template>
                </column>
                <column field="nome" header="Comprador" :sortable="true">
                    <template #body="slotProps">
                        <p>{{ slotProps.data.nome }}</p>
                    </template>
                </column>
                <column field="situacaoDescricao" header="Situação" :sortable="true">
                    <template #body="slotProps">
                        <status :status="slotProps.data?.situacaoDescricao"></status>
                    </template>
                </column>
                <column field="integrado" header="Integrado" :sortable="true">
                    <template #body="slotProps">
                        <p>{{ slotProps.data.integrado }}</p>
                    </template>
                </column>
                <column field="identificadorPagamento" header="IdPagamento" :sortable="true">
                    <template #body="slotProps">
                        <p>{{ slotProps.data.identificadorPagamento }}</p>
                    </template>
                </column>
                <column field="tipoPagamentoDescricao" header="Tipo de Pagamento" :sortable="true">
                    <template #body="slotProps">
                        <p>{{ slotProps.data.tipoPagamentoDescricao }}</p>
                    </template>
                </column>
                <column field="movimentoManutencaoId" header="IdMov" :sortable="true">
                    <template #body="slotProps">
                        <p>{{ slotProps.data.movimentoManutencaoId }}</p>
                    </template>
                </column>
                <column field="nomeUsuarioCadastro" header="Quem Cadastrou" :sortable="true">
                    <template #body="slotProps">
                        <p>{{ slotProps.data.nomeUsuarioCadastro }}</p>
                    </template>
                </column>
                <column
                    field="dataCadastroFormatada"
                    header="Data de Criação"
                    :sortable="true"
                    :sortField="'dataCadastro'"
                    :sortFunction="ordenacaoDataCadastro"
                >
                    <template #body="slotProps">
                        <p>{{ slotProps.data.dataCadastroFormatada }}</p>
                    </template>
                </column>
                <column field="produto.valor" header="Valor Total" :sortable="true">
                    <template #body="slotProps">
                        <p>{{ slotProps.data.produto?.valorFormatado }}</p>
                    </template>
                </column>
            </template>
        </tabela>
    </painel>
    <router-view></router-view>
</template>

<script>
import Services from './service';
import Filtros from './Filtros.vue';
import BtnExportar from './BtnExportar.vue';
import BtnReenviarEmail from './BtnReenviarEmail.vue';
import BtnRelatorioConciliacao from './BtnRelatorioConciliacao.vue';
export default {
    components: {
        Filtros,
        BtnExportar,
        BtnReenviarEmail,
        BtnRelatorioConciliacao,
    },
    data() {
        return {
            links: [],
            error: null,
            produtoCheckoutSelecionados: [],
        };
    },
    emits: ['limparSelecao'],
    mounted() {
        this.buscaLinks();
    },

    methods: {
        filtroPadraoHoje() {
            const hoje = this.$moment().format('YYYY-MM-DD');
            return {
                periodoInicial: hoje,
                periodoFinal: hoje,
            };
        },
        buscaLinks(filtro) {
            this.$store.dispatch('addRequest');
            const filtroFinal = filtro ?? this.filtroPadraoHoje();
            Services.obterProdutosCheckouts(filtroFinal)
                .then((response) => {
                    this.links = response.data.sort((a, b) => {
                        const dateA = new Date(a.dataCadastro ?? 0).getTime();
                        const dateB = new Date(b.dataCadastro ?? 0).getTime();
                        return dateB - dateA;
                    });
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: 'Erro ao buscar links de pagamentos',
                        life: 3000,
                    });
                    this.error = error;
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest');
                });
        },

        atualizar() {
            this.buscaLinks();
        },

        toDetalhar(checkout) {
            this.$router.push({
                name: 'links-pagamentos-detalhes',
                params: {
                    id: checkout.produtoCheckoutId,
                },
            });
        },
        obterProdutoCheckoutSelecionado(produtoCheckoutSelecionado) {
            if (produtoCheckoutSelecionado) {
                this.produtoCheckoutSelecionados.push(produtoCheckoutSelecionado.produtoCheckoutId);
            }
        },
        limparProdutoCheckoutsSelecionados() {
            this.produtoCheckoutSelecionados = [];
        },
        ordenacaoDataCadastro(event) {
            event.data.sort((a, b) => {
                const dateA = new Date(a.dataCadastro ?? 0).getTime();
                const dateB = new Date(b.dataCadastro ?? 0).getTime();

                return event.order * (dateA - dateB);
            });
        },
        abrirLink(url) {
            if (url) {
                const indiceCompra = url.indexOf('#/compra');
                if (indiceCompra !== -1) {
                    const rotaCompra = url.substring(indiceCompra);
                    const { protocol, host } = window.location;
                    const urlCompleta = `${protocol}//${host}/${rotaCompra}`;
                    window.open(urlCompleta, '_blank', 'noopener');
                } else {
                    window.open(url, '_blank', 'noopener');
                }
            }
        },
    },

    computed: {
        mostrarListagem() {
            return this.$route.name == 'links-pagamentos';
        },
    },

    watch: {
        $route(to) {
            if (to.name == 'links-pagamentos') {
                if (this.$store.getters.atualizar) {
                    this.buscaLinks();
                    this.$store.dispatch('setAtualizar', false);
                }
            }
        },
    },
};
</script>
